export default {
	filters: {
		expressions(strategy) {
			return strategy.condition.expressions.map((v, index) => {
				var text = ''
				if (index > 0) {
					text += v.operator
				}
				if (v.valueLeft && v.symbolLeft) {
					text += ` ${v.valueLeft} ${v.symbolLeft}`
				}
				text += ` ${v.variables} `
				if (v.valueRight && v.symbolRight) {
					text += ` ${v.symbolRight} ${v.valueRight}`
				}
				return text
			}).join(' ')
		},
		strategy(strategy) {
			const { details, functionName }= strategy.strategy
			if (functionName === 'EQ') {
				return `budget = ${details[0].variable} ${details[0].operator} ${details[0].number}`
			}
			return `budget =${functionName}(${details[0].variable} ${details[0].operator} ${details[0].number}, ${details[1].variable} ${details[1].operator} ${details[1].number})`
		}
	}
}